import { canonicalRole, knownRoleId, roleFromId } from "@web/config/roles";
import type { AuthUser, RawUser } from "@features/auth/types/types";
import { formatPersonName } from "@web/utils/formatters";

export function normalizeUsername(value: string) {
  const username = value.trim().toLowerCase();
  return username;
}

export function normalizeUser(raw: RawUser): AuthUser {
  const rawRole = canonicalRole(String(raw.role || ""));
  const roleId = Number(raw.role_id || raw.roleId || 0);
  const role = rawRole || roleFromId(roleId) || "SALES_CONSULTANT";
  const roles = Array.isArray(raw.roles)
    ? raw.roles.map((value) => canonicalRole(String(value))).filter(Boolean)
    : [role];
  const roleIds = Array.isArray(raw.roleIds)
    ? raw.roleIds
        .map(Number)
        .filter((value) => Number.isInteger(value) && value > 0)
    : roles.map(knownRoleId).filter((value) => value !== undefined);
  return {
    id: Number(raw.id || 0),
    name: formatPersonName(
      String(raw.name || raw.full_name || raw.username || "Orbit user"),
    ),
    email: String(raw.email || ""),
    username: typeof raw.username === "string" ? raw.username : undefined,
    phone: typeof raw.phone === "string" ? raw.phone : null,
    department: typeof raw.department === "string" ? raw.department : null,
    designation: typeof raw.designation === "string" ? raw.designation : null,
    departmentId:
      typeof raw.departmentId === "number" ? raw.departmentId : null,
    designationId:
      typeof raw.designationId === "number" ? raw.designationId : null,
    profileImageUrl:
      typeof raw.profile_image_url === "string"
        ? raw.profile_image_url
        : typeof raw.profileImageUrl === "string"
          ? raw.profileImageUrl
          : null,
    role,
    roleId: roleId || knownRoleId(role) || 0,
    roles,
    roleIds,
    permissions: Array.isArray(raw.permissions)
      ? raw.permissions.map(String)
      : [],
    status: typeof raw.status === "string" ? raw.status : undefined,
    authProvider:
      typeof raw.auth_provider === "string" ? raw.auth_provider : undefined,
  };
}
